import React from "react";
import { Link } from "react-router-dom";
import { PageContainer } from "../components/PageContainer";
import { Seo } from "../components/Seo";
import {
  pageHeadingClasses,
  pageLeadClasses,
  sectionCardClasses,
  subtleEyebrowClasses,
} from "../styles/pageClasses";

export default function Privacy() {
  return (
    <PageContainer maxWidth="4xl">
      <Seo
        title="Privacy Policy"
        description="Learn how Summer Jobs in Greece handles limited personal data for the website and private admin area."
        path="/privacy"
      />

      <div className={`${sectionCardClasses} space-y-6`}>
        <Link to="/blog" className="inline-flex text-sm font-medium text-[#a2572b] underline-offset-4 hover:underline">
          Back to Blog
        </Link>
        <span className={subtleEyebrowClasses}>Privacy</span>
        <h1 className={pageHeadingClasses}>Privacy Policy</h1>
        <p className={pageLeadClasses}>
          This Privacy Policy explains how Summer Jobs in Greece handles personal data when you visit the website or use the private admin area.
        </p>

        <div className="space-y-4 text-sm leading-7 text-[#34566a]">
          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Who we are</h2>
            <p>
              Summer Jobs in Greece publishes editorial travel content, seasonal job information, and admin-managed website content.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">What data we may collect</h2>
            <p>For ordinary visitors reading the public site, we do not currently intend to ask for account registration, public uploads, or active contact-form submissions. The only personal data we actively manage at this stage relates to the private admin area used to maintain the website and publish content.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Why we process data</h2>
            <p>We process limited admin-related data to operate the website, manage access to the private admin area, publish and maintain content, and keep the service secure.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Legal bases</h2>
            <p>We rely on legitimate interests for basic website administration, security, and operation. If new features are introduced later, such as public contact handling, analytics, or marketing tools, this policy will be updated and any required consent will be requested where necessary.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Cookies and tracking</h2>
            <p>At the time of writing, the site is not intended to use non-essential cookies, analytics cookies, advertising cookies, or marketing trackers for ordinary visitors. If that changes in future, this policy will be updated and any required consent mechanism will be introduced.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Sharing and service providers</h2>
            <p>We may use service providers to host the website, manage infrastructure, and support the private admin workflow. They process data only as needed to run the service.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Data retention</h2>
            <p>At this stage, the public website is intended mainly for reading content and does not currently ask ordinary visitors to submit personal data. Limited data may still be processed in the private admin area to operate and secure the site.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Your rights</h2>
            <p>If data protection law applies to you, you may have the right to ask for access to personal data, request corrections or deletion, or raise concerns with a data protection authority.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Contact</h2>
            <p>For privacy questions or requests, contact us at <a className="underline" href="mailto:contact@summerjobsingreeceguide.com">contact@summerjobsingreeceguide.com</a>.</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-[#213547]">Updates</h2>
            <p>We may update this Privacy Policy from time to time to reflect legal, operational, or product changes. The latest version published on this page will apply.</p>
          </section>
        </div>
      </div>
    </PageContainer>
  );
}
